function loadRecaptchaDownloadRequest(form) {
    if (typeof grecaptcha == 'undefined') {
        alert('Ops! SI è verificato un errore. Riprova più tardi...');
    } else {
        // grecaptcha.ready(function() {
            grecaptcha.execute(recaptcha_key, {action: 'download_request'}).then(function (token) {
                var recaptchaResponse = document.getElementById('download_request_recaptcha');
                recaptchaResponse.value = token;

                $.ajax({
                    url: url__download_request_send,
                    data: new FormData(document.getElementById('download_request-form')),// the formData function is available in almost all new browsers.
                    type: "post",
                    contentType: false,
                    processData: false,
                    cache: false,
                    dataType: "json", // Change this according to your response from the server.
                    // error: function(err) {
                    //     alert('Ops! SI è verificato un errore. Riprova più tardi.');
                    // },
                    success: function (data) {
                        $('form#download_request-form').replaceWith(data.html);
                        setTimeout(function () {
                            initFormDownloadRequest();
                        }, 500);
                        if (data.result) {
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                'event': 'submit',
                                'form_submitted': 'contact'
                            });
                            fbq_trackCustom('submit__contact');

                            if (data.newsletter) {
                                dataLayer.push({
                                    'event': 'submit',
                                    'form_submitted': 'newsletter'
                                });
                                fbq_trackCustom('submit__newsletter');
                                $('#download_request_newsletter_addon').removeClass('D(n)');
                            } else {
                                $('#download_request_newsletter_addon').addClass('D(n)');
                            }

                            $('#download_request_success_modal').modal('show');
                        }
                    },
                    complete: function () {
                        // console.log("Request finished.");
                    }
                });
            });
        // });
    }
}

var submitHandlerDownloadRequest = function(e) {
    e.preventDefault();
    e.target.removeEventListener('submit', submitHandlerDownloadRequest, false);

    document.getElementById('download_request-form-submit').classList.add('d-none');
    document.getElementById('download_request-form-loader').classList.remove('d-none');

    var form = $(this);
    loadRecaptchaDownloadRequest(form);
};

function initFormDownloadRequest() {
    document.getElementById('download_request-form').addEventListener("submit", submitHandlerDownloadRequest);
}

if (document.getElementById('download_request-form')) {
    initFormDownloadRequest();
}